// src/features/groups/components/GroupCreate.tsx - VERSIÓN SIMPLIFICADA
import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  useTranslate,
  useNotify,
  useRedirect,
} from 'react-admin';
import { Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import { MyToolbar } from '../../../components/forms/MyToolbar';
import { MyFormContainer } from '../../../components/forms/MyFormContainer';
import { 
  CenteredFormLayout,
  MyFormSection 
} from '../../../components/forms/MyFormLayout';

import { useGroupValidation } from '../hooks/useGroupValidation';
import { GroupFormData, prepareGroupForAPI } from '../types';

export const GroupCreate: React.FC = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const redirect = useRedirect();
  
  const { validateGroupName, validateDescription } = useGroupValidation();

  const transform = (data: GroupFormData) => prepareGroupForAPI(data);
  
  const handleSuccess = () => {
    notify(translate('resources.groups.notifications.created', 'Grupo creado con éxito'), { type: 'success' });
    redirect('/groups');
  };
  
  const handleError = (error: any) => {
    console.error('Error creating group:', error);
    notify(error.message || translate('resources.groups.errors.create', 'Error al crear el grupo'), { type: 'error' });
  };
  
  const handleCancel = () => redirect('/groups');

  return (
    <Create
      title={translate('resources.groups.titles.create', 'Crear Grupo')}
      transform={transform}
      mutationOptions={{ onSuccess: handleSuccess, onError: handleError }}
      redirect={false}
    >
      <MyFormContainer maxWidth="lg">
        <SimpleForm
        
          toolbar={
            <MyToolbar 
              onCancel={handleCancel} 
              resource="groups" 
              showDelete={false} 
            />
          }
        >

          <CenteredFormLayout>
            <MyFormSection
              title={translate('resources.groups.sections.new_group_title', 'Nuevo Grupo')}
              subtitle={translate('resources.groups.sections.new_group_subtitle', 'Complete los datos para crear un nuevo grupo')}
              icon={<AddIcon />}
              variant="card"
            >
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                gap: 3 
              }}>
                <TextInput
                  source="name"
                  label={translate('resources.groups.fields.name', 'Nombre del Grupo')}
                  validate={[required(), validateGroupName]}
                  fullWidth
                  variant="outlined"
                  helperText={translate(
                    'resources.groups.help.name',
                    'Nombre único que identifica al grupo'
                  )}
                />

                <TextInput
                  source="description"
                  label={translate('resources.groups.fields.description', 'Descripción')}
                  validate={validateDescription}
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  helperText={translate(
                    'resources.groups.help.description',
                    'Descripción opcional del grupo (máx. 500 caracteres)'
                  )}
                />
              </Box>
            </MyFormSection>
          </CenteredFormLayout>
        </SimpleForm>
      </MyFormContainer>
    </Create>
  );
};

export default GroupCreate;